import { Link } from 'react-router-dom';
import { categories } from '@/mocks/movies';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h4 className="text-lg font-heading font-bold text-background-50 mb-4">
                屁屁影院
              </h4>
              <p className="text-sm text-foreground-400 leading-relaxed">
                屁屁影院是您最佳的在线观影平台，汇聚海量高清电影、电视剧、动漫及综艺节目，无需注册即可免费畅享。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                影片分类
              </h4>
              <ul className="space-y-2.5">
                {categories.map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-400 hover:text-background-50 transition-colors"
                    >
                      {cat.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                快速链接
              </h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    首页
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    关于我们
                  </Link>
                </li>
                <li>
                  <Link to="/category/dianying" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    热门电影
                  </Link>
                </li>
                <li>
                  <Link to="/category/dianshiju" className="text-sm text-foreground-400 hover:text-background-50 transition-colors">
                    最新剧集
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">
                联系我们
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-mail-line"></i>
                  <span>contact@pipicinema.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-customer-service-2-line"></i>
                  <span>在线客服：每日 9:00-24:00</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-400">
                  <i className="ri-map-pin-line"></i>
                  <span>中国·北京</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} 屁屁影院 - 版权所有 | 本站内容仅供学习交流使用
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">
                隐私政策
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">
                服务条款
              </a>
              <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors" rel="nofollow">
                DMCA
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}